<style>
    .mat-typography {
        background-color: #32325d !important
    }

    body {
        background-color: #32325d !important
    }

    .example-card {
        max-width: 400px;
        margin: auto;
        text-align: center !important;
        padding: 20px;
        margin-top: 100px;
    }

    .example-header-image {
        width: 100px;
        height: auto;
        margin: auto;
        padding-bottom: 10px;
        margin-top: 16px !important;
    }

    .mat-card-header-text {
        display: none !important;
    }

    .footer-image {

        height: 35px;
        background: transparent;
        padding-top: 10px;
        width: auto;
        margin: 10px auto !important;


    }

    #mainText {

        font-family: inherit;
        /* font-weight: 600; */
        font-weight: 500;
        line-height: 1.5;
        margin-bottom: 0.5rem;
        color: #32325d;

    }
</style>
<mat-card class="example-card">

    <mat-card-content>
        <img mat-card-image class="example-header-image"
            src="https://assets.itrustpro.com/kennel/assets/logos/runloyal1.png" alt="Runloyal">
        <mat-divider></mat-divider>
        <h1 style="padding-top: 50px;padding-bottom: 10px;" id="mainText">{{ message }}</h1>
        <!-- <p>Appointment Confirmed !</p> -->
        <!-- <p *ngIf="success">We can't wait to see {{pet_names}} at {{start_time_str}} To {{end_time_str}} at {{displayAddress}}</p> -->

        <!-- <section class="example-section" style="padding-bottom: 10px;">
            <mat-checkbox class="example-margin">Save this card securely for future transaction.</mat-checkbox>           
          </section> -->
        <!-- <mat-card-actions style="padding-bottom: 20px;">
            <button mat-button style="background-color: #41A049 !important;color:white"
                (click)="goToAppointmentPage()">OK</button>
        </mat-card-actions> -->
    </mat-card-content>

    <mat-divider></mat-divider>
    <mat-card-footer>
        <a href="https://www.runloyal.com/" target="_blank" class="text-dark"><img mat-card-image class="footer-image"
                src="https://assets.itrustpro.com/kennel/assets/portal/madewithlove1.png" alt="Runloyal">
        </a>
    </mat-card-footer>

</mat-card>